import React from 'react'
import { ThemeConfig } from '../../utils/themeConfig'

interface StepIndicatorProps {
  themeConfig: ThemeConfig
}

export default function StepIndicator({ themeConfig }: StepIndicatorProps) {
  return (
    <div className="mb-6 hidden lg:flex items-center justify-center gap-2">
      <div className="flex items-center gap-2">
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
          style={{ backgroundColor: themeConfig.primaryColor }}
        >
          1
        </div>
        <span className="text-sm font-medium" style={{ color: themeConfig.accentTextColor }}>
          填写信息
        </span>
      </div>
      <div className="w-12 h-0.5 bg-gray-200"></div>
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-200 text-gray-500 text-sm font-semibold">
          2
        </div>
        <span className="text-sm text-gray-500">支付验证</span>
      </div>
      <div className="w-12 h-0.5 bg-gray-200"></div>
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-200 text-gray-500 text-sm font-semibold">
          3
        </div>
        <span className="text-sm text-gray-500">生成报告</span>
      </div>
    </div>
  )
}
